var map = {
	"./404.svg": 3901,
	"./aimychat-favicon.ico": 580,
	"./aimychat-logo.svg": 5456,
	"./arrow.svg": 9651,
	"./cc.svg": 3466,
	"./fb.svg": 2314,
	"./ico.svg": 6606,
	"./icons/block.svg": 6550,
	"./icons/chats.svg": 9685,
	"./icons/chevron-left.svg": 7758,
	"./icons/chevron-right.svg": 7504,
	"./icons/delete.svg": 2652,
	"./icons/edit.svg": 6431,
	"./icons/filter.svg": 4065,
	"./icons/forward.svg": 847,
	"./icons/gears.svg": 2218,
	"./icons/headset.svg": 8619,
	"./icons/message.svg": 911,
	"./icons/prompter-robot.svg": 1217,
	"./icons/robot.svg": 5528,
	"./icons/settings.svg": 150,
	"./icons/sign-in.svg": 7716,
	"./icons/statistics.svg": 7920,
	"./icons/user-group.svg": 773,
	"./logo-source.svg": 3194,
	"./page-404.svg": 8285,
	"./platform-favicon.ico": 9354,
	"./platform-logo.svg": 3569,
	"./product-icon-platform-t.svg": 2748,
	"./product-icon-platform.svg": 3604,
	"./product-icon-visual-editor-t.svg": 8800,
	"./product-icon-visual-editor.svg": 5974,
	"./search.svg": 5784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7165;